export default class Deck {
    constructor() {
        this.cards = [
            { id: 1, name: 'card1' },
            { id: 2, name: 'card2' },
            { id: 3, name: 'card3' },
            { id: 4, name: 'card4' },
            { id: 5, name: 'card5' },
            { id: 6, name: 'card6' },
            { id: 7, name: 'card7' },
        ];
    }

    getCardByPosition(id) {
        return this.cards[id];
    }

    /**
     * Function gets the value of the card without the need of doing so manualy.
     * Function expects card object that has "name" attribute.
     */
    getCardValue(card) {
        return card.name;
    }
}
